export enum ApparelExtraPrintAreas {
  ShortSleeveLeft = 'shsll',
  ShortSleeveRight = 'shslr',
  InnerLabel = 'inlbl',
  BackLabel = 'bcklbl',
}
